/**
 * Filters company client edges for project client pickers when Sage Intacct entity scoping applies.
 * When a location entity is selected on the project, includes Forecast-only clients (not imported
 * from Sage) and Sage-linked clients whose entity matches. When entity field does not apply or no
 * entity is stored, returns all clients (sorted).
 *
 */
export function filterCompanyClientsForSageEntity(companyClientEdges, params) {
	const {showSageIntacctEntityField, normalizedSageLocationId, projectClientId} = params;
	const clients = [...companyClientEdges];
	clients.sort((a, b) => a.node.name.localeCompare(b.node.name));

	if (!showSageIntacctEntityField || normalizedSageLocationId == null) {
		return clients;
	}
	const isLinkedToSageIntacct = edge => {
		const customerId = edge.node.sageIntacctCustomerId;
		return customerId != null && String(customerId).trim() !== '';
	};
	const matchesSelectedEntity = edge => {
		const id = edge.node.sageIntacctLocationEntityId;
		if (id == null || String(id).trim() === '') {
			return false;
		}
		return String(id).trim() === normalizedSageLocationId;
	};
	const filtered = clients.filter(edge => !isLinkedToSageIntacct(edge) || matchesSelectedEntity(edge));
	if (projectClientId && !filtered.some(e => e.node.id === projectClientId)) {
		const current = clients.find(e => e.node.id === projectClientId);
		if (current) {
			return [...filtered, current];
		}
	}
	return filtered;
}
